import React from "react"
import { useSelector } from "react-redux"
import { ROLE_BASED_PERMISSIONS } from "constants/permissions"

type WithAccessControlProps = {
  resource: string;
  action: string;
  fallback?: React.ReactNode;
};

export default function withRoleBasedPermission<P extends object>(WrappedComponent: React.ComponentType<P>) {
  function WithRoleBasedPermission(props: P & WithAccessControlProps) {
    const { resource, action, fallback = null, ...otherProps } = props

    const role = useSelector((state: any) => state.global.role)

    const rolePermission = ROLE_BASED_PERMISSIONS[role as keyof typeof ROLE_BASED_PERMISSIONS]

    // @ts-ignore
    const hasPermission = action?.length ? (rolePermission?.[resource] ? rolePermission?.[resource]?.[action] === true : true) : true

    return hasPermission ? (
      <WrappedComponent {...(otherProps as P)} />
    ) : (
      <>{fallback}</>
    )
  }

  return WithRoleBasedPermission
}
